import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface NotificationProps {
  message: string;
}
export function Notification({
  message
}: NotificationProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2800); // Slightly shorter than the parent timeout to allow for fade out
    return () => clearTimeout(timer);
  }, []);
  return <div className={`fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-283">
      <CheckCircleIcon size={20} className="mr-2 text-white" data-id="element-284" />
      <span data-id="element-285">{message}</span>
    </div>;
}